import { defineMessages } from 'react-intl';

export const muralDataFormatOptionsMessages = defineMessages({
	comments: {
		id: 'import-feedback.data-format-options.mural.comments',
		defaultMessage: 'Comments',
		description:
			'A single dropdown option indicating comments in Mural, as part of a feedback survey',
	},
	stickyNotes: {
		id: 'import-feedback.data-format-options.mural.sticky-notes',
		defaultMessage: 'Sticky Notes',
		description:
			'A single dropdown option indicating sticky notes in Mural, as part of a feedback survey',
	},
	borders: {
		id: 'import-feedback.data-format-options.mural.borders',
		defaultMessage: 'Borders',
		description:
			'A single dropdown option indicating borders in Mural, as part of a feedback survey',
	},
	draw: {
		id: 'import-feedback.data-format-options.mural.draw',
		defaultMessage: 'Draw',
		description:
			'A single dropdown option indicating draw feature in Mural, as part of a feedback survey',
	},
	websiteEmbeds: {
		id: 'import-feedback.data-format-options.mural.website-embeds',
		defaultMessage: 'Website Embeds',
		description:
			'A single dropdown option indicating website embeds in Mural, as part of a feedback survey',
	},
	tables: {
		id: 'import-feedback.data-format-options.mural.tables',
		defaultMessage: 'Tables',
		description:
			'A single dropdown option indicating tables in Mural, as part of a feedback survey',
	},
	gifs: {
		id: 'import-feedback.data-format-options.mural.gifs',
		defaultMessage: 'GIFs',
		description: 'A single dropdown option indicating GIFs in Mural, as part of a feedback survey',
	},
	text: {
		id: 'import-feedback.data-format-options.mural.text',
		defaultMessage: 'Text',
		description:
			'A single dropdown option indicating text/word data in Mural, as part of a feedback survey',
	},
	stamps: {
		id: 'import-feedback.data-format-options.mural.stamps',
		defaultMessage: 'Stamps',
		description:
			'A single dropdown option indicating stamps in Mural, as part of a feedback survey',
	},
	tags: {
		id: 'import-feedback.data-format-options.mural.tags',
		defaultMessage: 'Tags',
		description: 'A single dropdown option indicating tags in Mural, as part of a feedback survey',
	},
	mindMaps: {
		id: 'import-feedback.data-format-options.mural.mind-maps',
		defaultMessage: 'Mind Maps',
		description:
			'A single dropdown option indicating mind maps in Mural, as part of a feedback survey',
	},
	colors: {
		id: 'import-feedback.data-format-options.mural.colors',
		defaultMessage: 'Colors',
		description:
			'A single dropdown option indicating colors in Mural, as part of a feedback survey',
	},
	connectors: {
		id: 'import-feedback.data-format-options.mural.connectors',
		defaultMessage: 'Connectors',
		description:
			'A single dropdown option indicating connectors in Mural, as part of a feedback survey',
	},
	rotations: {
		id: 'import-feedback.data-format-options.mural.rotations',
		defaultMessage: 'Rotations',
		description:
			'A single dropdown option indicating rotations in Mural, as part of a feedback survey',
	},
	shapes: {
		id: 'import-feedback.data-format-options.mural.shapes',
		defaultMessage: 'Shapes',
		description:
			'A single dropdown option indicating shapes in Mural, as part of a feedback survey',
	},
	lockedElements: {
		id: 'import-feedback.data-format-options.mural.locked-elements',
		defaultMessage: 'Locked Elements',
		description:
			'A single dropdown option indicating locked elements in Mural, as part of a feedback survey',
	},
	other: {
		id: 'import-feedback.data-format-options.mural.other',
		defaultMessage: 'Other',
		description:
			'A single dropdown option indicating any feature that is not listed by the other options, as part of a feedback survey',
	},
});
